import Layout from "components/layout";
import Footer from "components/frontpage/footer";
import { getAllPostIds, getPostData } from "utils/posts";
import { GetStaticProps } from "next";

export interface PostData {
  id: string;
  title: string;
  contentHtml: string;
  categoryName: string;
  categoryColor: string;
  description: string;
  featured: string; //string not boolean since coming from the markdown frontmatter data
}

interface DocsPageProps {
  postData: PostData;
}

const DocsPage: React.FC<DocsPageProps> = ({ postData }) => {
  return (
    <Layout
      headerTitle={"Documentation"}
      title={`${postData.title} | Symbola Documentation`}
    >
      <div className="relative py-16 bg-gray-50 ">
        <div className="hidden lg:block lg:absolute lg:inset-y-0 lg:w-full">
          <div
            className="relative  text-lg max-w-prose mx-auto"
            aria-hidden="true"
          ></div>
        </div>
        <div className="relative px-4 sm:px-6 lg:px-8">
          <div className="text-lg max-w-prose mx-auto">
            <h1>
              <span className="block text-base text-center text-blue-600 font-semibold tracking-wide uppercase">
                DOCUMENTATION
              </span>
              <span className="mt-2 block text-3xl text-center leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                {postData.title}
              </span>
            </h1>
          </div>
          <div className="mt-6 prose prose-blue mx-auto">
            <div dangerouslySetInnerHTML={{ __html: postData.contentHtml }} />
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export async function getStaticPaths() {
  const paths = getAllPostIds();
  return { paths, fallback: false };
}

export const getStaticProps: GetStaticProps = async (context) => {
  const postData = await getPostData(context.params.id);
  return {
    props: {
      postData,
    },
  };
};

export default DocsPage;
